import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { setUserAvatar } from '../../../../store/account/userSlice';
import UpdateProfile from './UpdateProfile';
import { useSignOutUser } from '../../../../store/Apis/UserApi';
import { useNavigate } from 'react-router-dom';
import CancelSubscriptionModal from './CancelSubscriptionModal';
import SettingsIcon from '../../../../Custom-imeges/SettingsIcon';
import ManagePlanIcon from '../../../../Custom-imeges/ManagePlanIcon';
import { stringToHslColor } from '../../../../Helper';
import EditPinIcon from '../../../../Custom-imeges/EditPinIcon';
import { useManageMySubscription } from '../../../../store/Apis/StripeApi';
import { Typography } from '@mui/material';

const UserProfile = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const userDataProfile = useAppSelector((state) => state.User.userData);
    const [showCancelSub, setShowCancelSub] = useState(false);
    const [profilePictureUrl, setProfilePictureUrl] = useState<string>();
    const pictureUrl = useAppSelector((s) => s.User?.profilePictureURL);
    const signOutUser = useSignOutUser();
    const [colorAvatar, setColorAvatar] = useState<string>();
    const [showUpdateProfileModal, setShowUpdateProfileModal] = useState(false);
    const darkMode = useAppSelector((state) => state.User.darkMode);
    const User = useAppSelector((s) => s.User);
    const [showCancelSubModal, setShowCancelSubModal] = useState(false);
    const [showUserProfile,setShowUserProfile] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null); 
    const {data: manageSubscriptionLink,isPending,isSuccess,refetch:manageSubscription} = useManageMySubscription();

  useEffect(() => {
    if (isSuccess && manageSubscriptionLink) {
      window.location.href = manageSubscriptionLink;
    }
  }, [isSuccess, manageSubscriptionLink]);

    const handleManageSubscription = () => {
      manageSubscription();
    }

    const handleOpenUserProfile = ()=> {
      setShowUserProfile(!showUserProfile)
    }

    const handleMouseEnter = () => {
    setShowCancelSub(true);
    };

    const handleMouseLeave = () => {
      setShowCancelSub(false);
    };
  
    const Logout = () => {
    signOutUser({ IsAuthenticated: false });
  };

    const switchToSettingsSide = () => {
    navigate("/settings");
    // handleCloseNavMenu()
  };

  const handleShowUpdateProfileModal = () => {
    setShowUpdateProfileModal(true);
  };

  const handleCloseUpdateProfileModal = () => {
    setShowUpdateProfileModal(false);
  };

  useEffect(() => {
    if (userDataProfile?.firstName && userDataProfile?.lastName) {
      const initials = `${userDataProfile.firstName.charAt(0)}${userDataProfile.lastName.charAt(0)}`;
      dispatch(setUserAvatar(initials));
    }
  }, [userDataProfile, dispatch]);

  useEffect(() => {
    if (
      userDataProfile?.firstName?.length &&
      userDataProfile?.lastName?.length
    ) {
      // Calculate and set the colorAvatar state
      const color = stringToHslColor(
        userDataProfile.firstName + userDataProfile.lastName,
        30,
        50
      );
      setColorAvatar(color);
    }
  }, [userDataProfile]);

    useEffect(() => {
      if (pictureUrl) setProfilePictureUrl(pictureUrl);
    }, [pictureUrl]);
  
    //Handel user profile image
    const renderUserProfile=(userData: any, colorAvatar: string | undefined , place?:string)=> {
    if (!userDataProfile) {
      return null;
    }
    const { avatarUrl, firstName, lastName } = userData;
    const initials = `${firstName?.charAt(0)}${lastName?.charAt(0)}`;
    const fullName = `${firstName} ${lastName}`;

    return (
      <>
        <div className="user-profile-image">
          {profilePictureUrl ? (
            <img
              className="profileImage"
              src={profilePictureUrl}
              alt="User Avatar" 
            />
          ) : (
            <span
              className="profileImage"
              style={{ backgroundColor: colorAvatar }}
            >
              {initials}
            </span>
          )}
          {place === "inDrop" && (
            <div className="user-pro-plan">
              <img src="/Images/GetConversations/upgrade-plan.svg" />
              <span>Premium</span>
            </div>
          )}
        </div>
        {place === "inDrop" && (
            <>
              <span className="user-name">{fullName}</span>
            </>
        )}
      </>
    );
  }
  const handleClickOutside = (event: MouseEvent) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target as Node)
        ) {
          setShowUserProfile(false);
        }
    };

    useEffect(() => {
      if (showUserProfile) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [showUserProfile]);
  return (
    <Dropdown show={showUserProfile} onMouseLeave={handleMouseLeave} ref={dropdownRef} 
    className={`user-profile-dropdown ${User.isSubscribed && "pro-plan"}`}>
      <div>
        <Dropdown.Toggle onClick={handleOpenUserProfile} className="profile-icn">
          <div>
            {renderUserProfile(userDataProfile, colorAvatar, "sidebar")}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="profileDropdown w-100">
          <Dropdown.Item onMouseOver={handleMouseLeave}>
            <div className="userInfo mt-3" style={{ position: "relative" }}>
              <div>
                <div
                  className="editProfileImage"
                  onClick={handleShowUpdateProfileModal}
                  style={{
                    transform: "translate(-50%, -50%)", // Center the icon
                    zIndex: 1000,
                    position: "absolute",
                    top: "43%",
                    left: "38%",
                  }}
                >
                  <div className="edit-profile-icn">
                    <div className='edit-icon'>
                        <EditPinIcon className="user-profile-edit-icon" />
                    </div>
                  </div>
                </div>
                <div className="profileUserImage ">
                  {renderUserProfile(userDataProfile, colorAvatar, "inDrop")}
                </div>
              </div>
              <p className="userEmail">{userDataProfile?.email}</p>
            </div>
          </Dropdown.Item>
          <Dropdown.Item>
            <>
              <div
                className="settings"
                onClick={() => switchToSettingsSide()}
                onMouseOver={handleMouseLeave}
              >
                <SettingsIcon />
                <Typography className="titleFont" sx={{color:"var(--Main_icons_color)"}}>Settings</Typography>
              </div>
              {User.isSubscribed && (
                <div className={`manageSubscriptions ${isPending && 'active'}`} onClick={handleManageSubscription}>
                  <ManagePlanIcon/>
                  <p className="titleFont manageTitle">Manage subscription</p>
                </div>
                )}
                </>
                </Dropdown.Item>
                <div className="cancelSubscriptions"
                style={{
                    display: showCancelSub ? "flex" : "none",
                }}
                >
                <p className="cancelTitle">Manage subscription</p>
                </div>
            <Dropdown.Item onClick={Logout} onMouseOver={handleMouseLeave}>
                <div className="d-flex align-items-center settings">
                    <img src="/Images/getConversations/logout.svg" />
                    <p className="logOutTitle mb-0">Log out</p>
                </div>
                </Dropdown.Item>
            </Dropdown.Menu>
            </div>
            <UpdateProfile
              showModel={showUpdateProfileModal}
              closeModal={handleCloseUpdateProfileModal}
              avatarBackground={colorAvatar}
            />
            {showCancelSubModal && (
            <CancelSubscriptionModal
                show={showCancelSubModal}
                handleClose={() => setShowCancelSubModal(false)}
                name="Cancel Subscription"
                message="You’ll lost all premium features"
              />
      )}
    </Dropdown>
  );
};

export default UserProfile;
